import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getUserDetailAction = createAsyncThunk('userDetail', async (object, { rejectWithValue }) => {
  const { tenantId, search, searchText } = object;
  let url = `/api/v1/tenants/user-list/${tenantId}`;
  if (search && searchText) {
    url += `?search=${encodeURIComponent(searchText)}`;
  }
  const response = await request(url, { method: 'GET' , auth: true});

  if (response?.data) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});